import Repository from "../Repository";
import { getAuthHeader } from "../../_helpers/apiHelper";

const resource = "/connector";

export default {
  getByCompany(user, companyId) {
    var config = {
      headers: getAuthHeader(user)
    };

    return Repository.get(`${resource}/company/${companyId}`, config);
  },

  createConnector(user, companyId, payload) {
    var config = {
      headers: getAuthHeader(user)
    };

    return Repository.post(`${resource}/${companyId}`, payload, config);
  },

  editConnector(user, connectorId, payload) {
    var config = {
      headers: getAuthHeader(user)
    };

    return Repository.put(`${resource}/${connectorId}`, payload, config);
  },

  getConnector(user, connectorId) {
    var config = {
      headers: getAuthHeader(user)
    };

    return Repository.get(`${resource}/${connectorId}`, config);
  },

  templates(user, active) {
    var config = {
      headers: getAuthHeader(user)
    };

    return Repository.get(`${resource}/templates?active=${active}`, config);
  },

  deleteConnector(user, connectorId) {
    var config = {
      headers: getAuthHeader(user)
    };

    return Repository.delete(`${resource}/${connectorId}`, config);
  }
};
